import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getNoticePopupById } from "../../../../service";
import NotificationDetailSkeleton from "../../../../components/skeleton/notification/notificationDetailSkeleton";
import { TopBar } from "../../../../widgets";
import { DividerThin } from "../../../../shared";
import dayjs from "dayjs";
const NoticePopupDetail = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [noticePopup, setNoticePopup] = useState<INoticePopup | undefined>(undefined);
    const [isInitLoading, setIsIntLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!id) navigate('/notification')
        requestNoticePopupById();
    }, [])

    const requestNoticePopupById = async () => {
        if (!id) return;
        const res = await getNoticePopupById(id)
        setNoticePopup(res.data);
        setIsIntLoading(false);
    }

    return <>
        {isInitLoading && <NotificationDetailSkeleton />}
        <TopBar title="공지 상세" rightIcon={false} position='fixed' thema='dark' />
        <div style={{ padding: '24px 20px 71px' }}>
            {noticePopup && <>
                <div className="sub-title/st3 base/black">{noticePopup.title}</div>
                <div className="body/b1 secondary/s500" style={{ marginTop: 'var(--space8)' }}>{dayjs(noticePopup.createdDate).format("YYYY년 MM월 DD일")}</div>
                <DividerThin style={{ marginBlock: '16px' }} />
                <div className="body/b3 secondary/s800" style={{ whiteSpace: 'pre-wrap' }}>
                    {noticePopup.content}
                </div>
            </>}
        </div>
    </>

}

export { NoticePopupDetail }